import Link from '@components/Link';
import Logo from '@hiredigital/ui/Logo';
import Styles from './Onboarding.module.scss';
import PropTypes from 'prop-types';
import IconLeftArrow from '@hiredigital/ui/Icon/icons/left.inline.svg';

const BackLink = ({ text, to, ...props }) => (
  <Link className={Styles.backLink} to={to} {...props}>
    <IconLeftArrow className={Styles.icon} />
    {text}
  </Link>
);

const Title = ({ title, children, ...props }) => (
  <h1 className={Styles.title} {...props}>
    {title || children}
  </h1>
);

const Description = ({ description, children, ...props }) => (
  <p className={Styles.description} {...props}>
    {description || children}
  </p>
);

const Content = ({ children, ...props }) => (
  <div className={Styles.contentLeft} {...props}>
    {children}
  </div>
);

const LeftArea = ({ title, description, children, ...props }) => {
  return (
    <div className={Styles.leftArea} {...props}>
      <div className={Styles.leftChild}>
        <Link href='/' className={Styles.logoContainer}>
          <Logo className={Styles.logo} type={Logo.Type.WHITE} site={'3'} />
        </Link>
        {(title || description) && (
          <Content>
            {title && <Title title={title} />}
            {description && <Description description={description} />}
          </Content>
        )}
        {children}
      </div>
    </div>
  );
};

LeftArea.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.node,
};

LeftArea.Title = Title;
LeftArea.Description = Description;
LeftArea.Content = Content;
LeftArea.BackLink = BackLink;

export default LeftArea;
